export type ResizeListener = (width: number, height: number) => void;

export class WorldBounds {
  width = 1;
  height = 1;
  private listeners: ResizeListener[] = [];

  set(width: number, height: number): void {
    if (width === this.width && height === this.height) return;
    this.width = Math.max(1, width);
    this.height = Math.max(1, height);
    for (const fn of this.listeners) fn(this.width, this.height);
  }

  onResize(fn: ResizeListener): void {
    this.listeners.push(fn);
  }

  get cx(): number {
    return this.width * 0.5;
  }

  get cy(): number {
    return this.height * 0.5;
  }
}
